<template>
  <div style="height:100%;">
    <Header></Header>
    <div class="container">
      <Menu></Menu>
      <div class="content">
        <transition name="page-transform" mode="out-in">
          <router-view></router-view>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import Header from './components/header.vue'
import Menu from './components/menu.vue'
export default {
  components: {
    Header,
    Menu
  }
}
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  height: calc(100% - 70px);
  background: rgba(245, 247, 251, 1);
  .content {
    flex: 1;
    height: 100%;
    overflow: scroll;
    overflow-x: hidden;
  }
}
</style>
